import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-wijmo-grid-ng',
	templateUrl: './wijmo-grid-ng.component.html',
	styleUrls: ['./wijmo-grid-ng.component.css']
})
export class WijmoGridNgComponent implements OnInit {
	@Input() data: any[];
	public columnBindings: string[];
	constructor() { }

	ngOnInit() {
		this.columnBindings = Object.keys(this.data[0]);
	}

}
